<template>
    <div class="modal-mask">
        <div class="modal-wrapper" id="conformbox">
            <div class="modal-wrapper-main">
                <div class="mz-header">
                    <span>确认加入人才库</span>
                    <span @click="close" class="iconfont icon-guanbi"></span>
                </div>
                <div class="mz-content">
                    <div class="mz-cqr">确认将 <span>{{name}}</span>加入企业人才库？</div>
                    <p class="mz-cxh">需要消耗10平台币完成操作</p>
                    <dl>
                        <dt>您将会获得以下权限：</dt>
                        <dd>显示简历的联系方式</dd>
                        <dd>随时随地查看人才信息</dd>
                        <dd>简历将被永久加入人才库</dd>
                    </dl>
                    <div class="mz-btn mz-btn-blue" @click="download"
                         :class="{'my-btn-gray':myinfo.collNum*1 == 0}">
                        {{myinfo.collNum ? '免费加入' : '暂无次数'}}
                    </div>
                    <div class="mz-sycs" style="position: relative;">
                        <span>剩余免费次数：{{myinfo.collNum}}次</span>
                        <span v-if="showpwd" style="position:absolute;top:12px;right: 4px;color: #ff4949;font-size: 12px;">请输入您的支付密码</span>
                    </div>
                    <div class="mz-btn mz-btn-orange"  v-if="!showpwd" @click="pingchange">使用平台币下载</div>
                    <div style="position: relative;width: 100%;height: 46px;" v-if="showpwd">
                        <ul class="mz-pwd">
                            <li v-for="item in pwdlist">{{item}}</li>
                        </ul>
                        <input @focus="focusInput"  v-model="pwdIinps" maxlength="6" placeholder="请输入密码" :type="inputType"
                               class="mz-btn mz-btn-orange mz-inp-orange"/>
                    </div>
                    <ul class="mz-account">
                        <li class="mz-content-l">当前账户余额：<span>{{myinfo.availableFunds}}元</span></li>
                        <li class="mz-content-r" @click="gocharge">我要充值>></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props:['id','name','close'],
        data(){
            return {
                myinfo: '',
                pwdIinps: '',
                pwdlist: ['', '', '', '', '', ''],
                showpwd:false,
                inputType:'text',
                options:{
                    text:'加载中，请稍后',
                    target:'#conformbox'
                }
            }
        },
        beforeRouteEnter(to, from, next){
            next();
        },
        beforeRouteLeave(to,from,next){
            this.inputType = 'text'
            next();
        },
        watch: {
            pwdIinps(newval, oldval){
                this.pwdlist[0] = newval[0]?'*':'';
                this.pwdlist[1] = newval[1]?'*':'';
                this.pwdlist[2] = newval[2]?'*':'';
                this.pwdlist[3] = newval[3]?'*':'';
                this.pwdlist[4] = newval[4]?'*':'';
                this.pwdlist[5] = newval[5]?'*':'';
                if(newval.length == 6){
                    this.buyinfo();
                }
            }
        },
        created(){
            this.getRemain();
        },
        methods: {
            focusInput(){
                this.inputType = 'password'
            },
            goback(){
              this.$router.back();
            },
            pingchange(){
                this.showpwd = true;
            },
            gocharge(){
                this.$router.replace({path:'/index/finance/recharge'})
            },
            buyinfo(){
                this.loadingObj = this.$loading(this.options);
                this.axios.get('/wapi/hr/buyResume?workerId='+this.id + '&password='+this.pwdIinps,).then(res => {
                    setTimeout(()=>{
                        this.loadingObj.close();
                    },300);
                    if(res.success){
                        this.$message({
                            type:'success',
                            duration:1500,
                            message:'添加成功，您可以在我的人才库中查看'
                        });
                        setTimeout(() => {
                           window.location.reload();
                        },400)
                    }else{
                        this.pwdIinps = "";
                    }
                })
            },
            getRemain(){
                this.axios.get('/wapi/company/getRemain').then(res => {
                    if (res.success) {
                        this.myinfo = res.data;
                    }
                })
            },
            download(){
                if (!this.myinfo.collNum) {
                    return;
                }
                this.loadingObj = this.$loading(this.options);
                this.axios.get('/wapi/hr/collWorker?workerId=' + this.id)
                    .then(res => {
                        setTimeout(()=>{
                            this.loadingObj.close();
                        },300);
                        if(res.success){
                            this.$message({
                                type:'success',
                                duration:1500,
                                message:'添加成功，您可以在我的人才库中查看'
                            });
                            setTimeout(() => {
                                window.location.reload();
                            },400)
                        }else{
                            this.pwdIinps = "";
                        }
                    })
            }
        }
    }

</script>
<style>
    .modal-mask {
        display: table;
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .25s linear;
    }

    .modal-wrapper {
        display: table-cell;
        position: fixed;
        z-index: 9001;
        top: 50%;
        left: 50%;
        vertical-align: middle;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transition: all .2s linear;
    }

    .modal-wrapper-main {
        width: 550px;
        min-height: 480px;
        border-radius: 8px;
        background-color: #fff;
        overflow: hidden;
        padding-bottom: 20px;
    }

    .mz-header {
        height: 60px;
        line-height: 60px;
        position: relative;
        color: rgba(0, 0, 0, 0.85);
        font-size: 20px;
        padding-left: 25px;
        border-bottom: 2px solid #EDEDED;
    }

    .mz-header .iconfont {
        font-size: 12px;
        position: absolute;
        right: 30px;
        height: 20px;
        color: rgba(0, 0, 0, 0.85);
        cursor: pointer;
    }

    .mz-content {
        width: 435px;
        margin: 0 auto;
        overflow: hidden;
    }

    .mz-content .mz-cqr {
        font-size: 20px;
        color: #42464B;
        margin: 32px 0 8px 0;
    }

    .mz-content .mz-cqr span {
        color: #057CF9;
        margin: 0 6px;
    }

    .mz-content .mz-cxh {
        font-size: 16px;
        color: #333333;
    }

    .mz-content dl {
        margin-top: 20px;
        overflow: hidden;
        padding-bottom: 20px;
    }

    .mz-content dl dt {
        font-size: 14px;
        color: #555;
        margin-bottom: 12px;
    }

    .mz-content dl dd {
        position: relative;
        line-height: 1.6;
        color: #999999;
        font-size: 16px;
    }

    .mz-content .mz-btn {
        height: 44px;
        border-radius: 4px;
        text-align: center;
        line-height: 44px;
        font-size: 14px;
        cursor: pointer;
    }

    .mz-content .mz-btn-orange {
        color: #ff971c;
        border: 1px solid #ff971c;
    }

    .mz-content .mz-btn-blue {
        color: #495fcd;
        border: 1px solid #495fcd;
        margin-top: 24px;
    }

    .mz-content .mz-sycs {
        color: #999;
        font-size: 14px;
        margin: 6px 0 14px 0;
    }

    .mz-content .mz-account {
        overflow: hidden;
        margin-top: 14px;
    }

    .mz-content .mz-content-l {
        font-size: 14px;
        color: #ff971c;
        float: left;
    }

    .mz-content .mz-content-r {
        font-size: 14px;
        color: #ff971c;
        text-decoration: underline;
        float: right;
        cursor: pointer;
    }

    .mz-content .my-btn-gray {
        background-color: #ccc;
        border-color: #ccc;
        color: #fff;
        cursor: text;
    }

    .mz-content .mz-inp-orange {
        text-align: left;
        text-indent: 10px;
        border: none;
        cursor: text;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        z-index: 10;
    }

    .mz-content .mz-pwd {
        width: 100%;
        overflow: hidden;
        padding-left: 1px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }
    .mz-content .mz-pwd li {
        float: left;
        width: 53px;
        height: 42px;
        border: 1px solid #ccc;
        margin-left: -1px;
        text-align: center;
        line-height: 42px;
        border-radius: 1px;
    }
</style>



// WEBPACK FOOTER //
// confirm.vue?5470ed5e